// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const de: KnowledgePagesCopy = {
  knowledgePage: 'Wissensseite',
  knowledgePages: 'Wissensseiten',
  featureOffTitle: 'Wissensseiten sind in diesem Arbeitsbereich nicht aktiviert.',
  featureOffBody: 'Unternehmenskontext und Quellen finden Sie weiterhin unter Wissen.',
  loadingPage: 'Seite wird geladen…',
  loadingSuggestion: 'Vorschlag wird geladen…',
  cancel: 'Abbrechen',
  tryAgain: 'Erneut versuchen',
  everyoneIn: 'Alle bei {company}',
  yourCompany: 'Ihrem Unternehmen',
  revision: 'Revision {n}',
  openRevision: 'Revision {n} öffnen',
  pageCount: 'one:Seite|other:Seiten',
  topicCount: 'one:Thema|other:Themen',
  sectionCount: 'one:Abschnitt|other:Abschnitte',
  lineCount: 'one:Zeile|other:Zeilen',
  documentCount: 'one:Dokument|other:Dokumente',
  changeCount: 'one:Änderung|other:Änderungen',
  newPageCount: 'one:neue Seite|other:neue Seiten',
  changedPageCount: 'one:geänderte Seite|other:geänderte Seiten',
  otherSectionCount: 'one:weiterer Abschnitt|other:weitere Abschnitte',
  characterCount: 'one:Zeichen|other:Zeichen',
  diffStats: '{sections} geändert · {added} hinzugefügt · {removed} entfernt',
  diffMatchesBase: 'Der vorgeschlagene Text stimmt mit der Ausgangsrevision überein.',
  diffIntroduction: 'Einleitung',
  diffOtherUnchanged: '{sections} unverändert.',
  timeJustNow: 'gerade eben',
  originImportedFrom: 'Importiert aus {path}',
  originImportedFromCommit: 'Importiert aus {path} @ {commit}',
  authorityApprovedInPoneva: 'In Poneva freigegeben',
  authorityImported: 'Importiert',
  authorityInRepository: '{canonicality} im Repository',
  authorityVerified: 'geprüft am {date}',
  authorRepositoryImport: 'Repository-Import',
  authorSuggestedInChat: 'Im Chat vorgeschlagen',
  authorSuggestedInChatWith: 'Im Chat mit {name} vorgeschlagen',
  authorSuggestedBy: 'Vorgeschlagen von {name}',
  authorSuggestedByApp: 'Von einer verbundenen App vorgeschlagen',
  authorSuggestedByColleague: 'Von einer Kollegin oder einem Kollegen vorgeschlagen',
  authorSuggestedByYou: 'Von Ihnen vorgeschlagen',
  authorSuggestedOnBehalf: 'Von {app} im Auftrag von {name} vorgeschlagen',
  authorSuggestedByAppOnBehalf: 'Von einer verbundenen App im Auftrag von {name} vorgeschlagen',
  authorSuggestedAndApproved: 'Von {name} vorgeschlagen und freigegeben',
  approverApprovedBy: 'freigegeben von {name}',
  approverAppliedBy: 'übernommen von {name}',
  kindCreatePage: 'Neue Seite',
  kindUpdatePage: 'Vorgeschlagene Änderung',
  kindArchivePage: 'Archivierung',
  statusConflict: 'Konflikt · Seite geändert',
  statusPending: 'Prüfung ausstehend',
  statusApproved: 'Freigegeben',
  statusRejected: 'Verworfen',
  statusWithdrawn: 'Zurückgezogen',
  statusSuperseded: 'Überholt',
  errRevisionConflict: 'Diese Seite wurde geändert, während Sie sie geprüft haben.',
  errProposalChanged:
    'Dieser Vorschlag wurde geändert, während Sie ihn geprüft haben. Prüfen Sie die neueste Version, bevor Sie entscheiden.',
  errPublishRequired:
    'Nur Personen mit Veröffentlichungsrechten im Unternehmen können Wissensänderungen freigeben oder Seiten importieren.',
  errProposalLimit:
    'In Ihrem Unternehmen warten bereits 200 Vorschläge auf Prüfung. Prüfen Sie einige, bevor Sie weitere vorschlagen.',
  errAuthorLimit:
    'Sie haben bereits 50 Vorschläge, die auf Prüfung warten. Warten Sie, bis über einige entschieden ist, oder ziehen Sie einige zurück, bevor Sie weitere vorschlagen.',
  errImportProposalLimit:
    'Dieser Import würde mehr geänderte Seiten zur Prüfung hinzufügen, als in die Prüfwarteschlange Ihres Unternehmens passen (höchstens 200). Entscheiden Sie unter Zur Prüfung über einige Vorschläge und übernehmen Sie den Import dann erneut.',
  errImportChanged:
    'Dies ist nicht der Import, den Sie geprüft haben. Öffnen Sie ihn erneut und prüfen Sie ihn, bevor Sie ihn übernehmen.',
  errImportItemNotFound: 'Dieses Dokument ist nicht mehr Teil des Imports.',
  errIdempotencyConflict:
    'Dieser Vorschlag wurde bereits mit anderem Inhalt gesendet. Laden Sie neu und versuchen Sie es erneut.',
  errImportHashMismatch:
    'Eine Datei in diesem Snapshot stimmt nicht mit ihrer erfassten Prüfsumme überein. Erstellen Sie den Snapshot neu und versuchen Sie es erneut.',
  errImportAlreadyApplied: 'Dieser Import wurde bereits übernommen.',
  errImportDiscarded: 'Dieser Import wurde verworfen. Wählen Sie die Snapshot-Datei erneut aus.',
  errImportDuplicateItem:
    'Dieser Snapshot führt dasselbe Dokument zweimal auf. Erstellen Sie den Snapshot neu.',
  errInvalidImport:
    'Poneva konnte diesen Snapshot nicht annehmen. Erstellen Sie ihn mit dem Snapshot-Skript neu und versuchen Sie es erneut.',
  errInvalidInput:
    'Poneva konnte diese Eingabe nicht annehmen. Prüfen Sie die Felder und versuchen Sie es erneut.',
  errImportLimit:
    'Zu viele Importe sind bereitgestellt, aber nicht übernommen. Übernehmen oder verwerfen Sie einige, bevor Sie einen weiteren bereitstellen.',
  errPageTooLarge: 'Eine Seite ist größer als 256 KB. Teilen Sie sie in kleinere Seiten auf.',
  errTooManySections:
    'Eine Seite hat mehr als 2.000 Überschriften. Teilen Sie sie in kleinere Seiten auf.',
  errPageLimit: 'Ihr Unternehmen hat das Limit von 2.000 Wissensseiten erreicht.',
  errCollectionLimit: 'Ihr Unternehmen hat das Limit von 100 Themen erreicht.',
  errProposalNotPending:
    'Über diesen Vorschlag wurde bereits entschieden. Der angezeigte Status ist aktuell.',
  errRequesterRemoved:
    'Die Person, die dies vorgeschlagen hat, gehört nicht mehr zu diesem Unternehmen, daher kann der Vorschlag nicht freigegeben werden.',
  errRevisionAlreadyCurrent: 'Diese Revision ist bereits die aktuelle.',
  errPageArchived:
    'Diese Seite wurde archiviert, während Sie sie geprüft haben. Prüfen Sie den Vorschlag erneut, bevor Sie entscheiden.',
  errAlreadyArchived: 'Diese Seite ist bereits archiviert.',
  errProposalForbidden:
    'Nur die Person, die dies vorgeschlagen hat, kann den Vorschlag zurückziehen.',
  errUnavailable: 'Wissensseiten sind gerade nicht verfügbar.',
  errTimeout: 'Poneva hat zu lange für die Antwort gebraucht.',
  errItemTooLarge: '{path} ist größer als 256 KB. Teilen Sie die Datei in kleinere Seiten auf.',
  errItemTooManySections:
    '{path} hat mehr als 2.000 Überschriften. Teilen Sie die Datei in kleinere Seiten auf.',
  errItemHashMismatch:
    '{path} stimmt nicht mit der erfassten Prüfsumme überein. Erstellen Sie den Snapshot neu und versuchen Sie es erneut.',
  errNoLongerAvailable: 'Dieses Element ist für Sie nicht mehr verfügbar.',
  errTooLargeToSend: 'Diese Datei ist zu groß zum Senden.',
  cardChecking: 'Status wird geprüft…',
  cardNotAvailable: 'Nicht verfügbar',
  cardStatusUnavailable: 'Status nicht verfügbar',
  cardUnshowable: 'Diese vorgeschlagene Wissensänderung konnte nicht angezeigt werden.',
  cardEyebrow: 'Vorgeschlagene Wissensänderung',
  cardLabel: 'Vorgeschlagene Wissensänderung · {title}',
  cardMissing: 'Dieser Vorschlag ist für Sie nicht mehr verfügbar.',
  cardUnknown:
    'Wir konnten den Stand dieses Vorschlags nicht prüfen. Öffnen Sie die Prüfung, um den Status zu sehen.',
  cardCheckAgain: 'Erneut prüfen',
  cardReview: 'Änderung prüfen',
  statusLineApproved: 'Freigegebenes Wissen',
  readyCount: 'one:bereit für die Suche|other:bereit für die Suche',
  preparingCount: 'one:in Vorbereitung|other:in Vorbereitung',
  attentionCount: 'one:benötigt Aufmerksamkeit|other:benötigen Aufmerksamkeit',
  topicsExplore: 'Thema erkunden',
  topicsAllPages: 'Alle Seiten',
  topicsOpenPages: 'Seiten öffnen',
  topicsEmpty:
    'Noch keine freigegebenen Seiten. Seiten enthalten ausführliches Unternehmenswissen mit vollständigem Revisionsverlauf.',
  reviewsTitle: 'Vorgeschlagene Seitenänderungen',
  reviewsTitleMine: 'Ihre vorgeschlagenen Seitenänderungen',
  reviewsIntro:
    'Jeder Vorschlag ist eine vollständige Revision mit Begründung und Belegen. Nichts ändert sich, bis Sie genau diese Revision freigeben.',
  reviewsIntroMine:
    'Ihre Vorschläge warten hier, bis eine Person mit Veröffentlichungsrechten im Unternehmen sie prüft. Bis dahin bleiben die Seiten unverändert.',
  loadPagesFailed: 'Wir konnten die Wissensseiten nicht laden.',
  loadProposalsFailed: 'Wir konnten die vorgeschlagenen Seitenänderungen nicht laden.',
  loadMoreFailed: 'Wir konnten keine weiteren Seiten laden.',
  otherPages: 'Weitere Seiten',
  loadTopicFailed: 'Wir konnten dieses Thema nicht laden.',
  revisionShort: 'R{n}',
  updatedOn: 'Aktualisiert am {date}',
  emptyTitle: 'Noch keine Wissensseiten.',
  emptyBody:
    'Seiten enthalten das freigegebene, ausführliche Wissen Ihres Unternehmens – Ausrichtung, Entscheidungen und Arbeitsweisen – und jede Revision bleibt erhalten. Importieren Sie aus einem Repository-Snapshot oder beginnen Sie eine Seite im Chat; eine Person mit Veröffentlichungsrechten gibt jede Seite frei, bevor sie als Unternehmenswissen gilt.',
  importFromSnapshot: 'Aus einem Repository-Snapshot importieren',
  startInChat: 'Seite im Chat beginnen',
  startInChatPrompt:
    'Hilf mir, eine Wissensseite für unser Unternehmen zu beginnen. Frag mich, was sie abdecken soll, und erfinde keine Inhalte. Sie bleibt ein Vorschlag, bis eine Person mit Veröffentlichungsrechten im Unternehmen sie freigibt.',
  loadingPages: 'Wissensseiten werden geladen…',
  filterLabel: 'Seiten nach Titel filtern',
  filterPlaceholder: 'Seiten filtern',
  importButton: 'Importieren',
  showingTopic: '{topic} wird angezeigt',
  showAllTopics: 'Alle Themen anzeigen',
  loadingTopic: 'Thema wird geladen…',
  noMatch: 'Keine Seiten passen zu „{filter}“.',
  topicNoPages: 'In diesem Thema gibt es noch keine freigegebenen Seiten.',
  loading: 'Wird geladen…',
  loadMore: 'Weitere Seiten laden',
  metaApproved: 'freigegeben am {date}',
  metaRepositoryAuthoritative: 'Repository bleibt maßgeblich',
  loadPageFailed: 'Wir konnten diese Seite nicht laden.',
  loadHistoryFailed: 'Wir konnten den Revisionsverlauf nicht laden.',
  outlineLabel: 'Seitenabschnitte',
  outlineToggle: 'Auf dieser Seite',
  loadingHistory: 'Revisionsverlauf wird geladen…',
  historyLabel: 'Revisionsverlauf',
  historyIntro:
    'Jede freigegebene Revision bleibt erhalten. Das Wiederherstellen einer früheren Revision erzeugt einen Vorschlag zur Prüfung; spätere Revisionen werden dabei nie gelöscht.',
  historyCurrent: 'Aktuell',
  historyViewing: 'Angezeigt',
  historyView: 'Anzeigen',
  historyViewAria: 'Revision {n} anzeigen',
  restoreAria: 'Als Vorschlag wiederherstellen: Revision {n}',
  restoreCreating: 'Vorschlag wird erstellt…',
  restore: 'Als Vorschlag wiederherstellen',
  restoreUnconfirmed:
    'Wir konnten nicht bestätigen, dass der Vorschlag erstellt wurde. Prüfen Sie Zur Prüfung, bevor Sie es erneut versuchen.',
  editTooLarge:
    'Diese Seite ist größer als 256 KB. Teilen Sie sie in kleinere Seiten auf, bevor Sie sie vorschlagen.',
  editConflict:
    'Diese Seite wurde geändert, während Sie sie bearbeitet haben. Kopieren Sie Ihren Text, öffnen Sie die neueste Revision und schlagen Sie die Änderung erneut vor.',
  editUnconfirmed:
    'Wir konnten nicht bestätigen, dass Ihr Vorschlag gesendet wurde. Prüfen Sie Zur Prüfung, bevor Sie ihn erneut senden.',
  editHeading: 'Änderung vorschlagen',
  editIntro:
    'Sie bearbeiten Revision {n}. Eine Person mit Veröffentlichungsrechten im Unternehmen prüft genau diese Änderung, bevor sie Revision {next} wird; bis dahin bleibt die Seite unverändert.',
  editOutdated:
    'Während Sie bearbeitet haben, wurde eine neuere Revision freigegeben. Kopieren Sie Ihren Text und beginnen Sie dann neu mit der neuesten Revision, damit deren Änderungen nicht verloren gehen.',
  editContentLabel: 'Seiteninhalt (Markdown)',
  editReasonLabel: 'Warum diese Änderung?',
  editReasonPlaceholder: 'Was sich geändert hat und woher es stammt.',
  editSending: 'Wird gesendet…',
  editSend: 'Zur Prüfung senden',
  editDiscardConfirm: 'Diese Bearbeitung verwerfen? Ihre Änderungen wurden noch nicht gesendet.',
  editNoChanges: 'Noch keine Änderungen.',
  editNeedsContent: 'Eine Seite braucht etwas Inhalt.',
  exportFailed: 'Wir konnten diese Seite nicht exportieren. Versuchen Sie es erneut.',
  askPagePrompt: 'Frage zur Wissensseite „{title}“ (Revision {n}, {link}):',
  askPageSectionPrompt: 'Frage zur Wissensseite „{title}“ § {section} (Revision {n}, {link}):',
  pageMissingTitle: 'Diese Seite ist nicht verfügbar.',
  pageMissingBody:
    'Sie wurde möglicherweise archiviert, oder Sie haben keinen Zugriff mehr auf das Wissen dieses Unternehmens.',
  pageArchived: 'Archiviert',
  viewingRevisionCurrent: 'Sie sehen Revision {n}; die aktuelle Revision ist {current}.',
  viewingRevisionOld: 'Sie sehen Revision {n}. Das ist nicht die aktuelle Revision.',
  openCurrent: 'Aktuelle öffnen',
  archivedBanner:
    'Diese Seite ist archiviert. Sie fließt nicht mehr in Antworten ein; ihr Verlauf bleibt erhalten.',
  pageViewsLabel: 'Seitenansichten',
  tabRead: 'Lesen',
  tabHistory: 'Verlauf',
  unknownSection:
    'Der verlinkte Abschnitt ist nicht Teil dieser Revision. Die ganze Seite wird angezeigt.',
  askAboutPage: 'Zu dieser Seite fragen',
  exporting: 'Wird exportiert…',
  exportMarkdown: 'Als Markdown exportieren',
  loadSuggestionFailed: 'Wir konnten diesen Vorschlag nicht laden.',
  evidenceSource: 'Quelle',
  evidenceFact: 'Unternehmenskontext',
  evidenceResult: 'Gespeicherte Arbeit',
  evidenceUrl: 'Webseite',
  evidenceDecision: 'Entscheidung',
  evidenceReference: 'Referenz',
  evidenceOpenPage: 'Wissensseite öffnen',
  evidenceOpenSource: 'Quelle öffnen',
  evidenceOpenFact: 'Unternehmenskontext öffnen',
  evidenceOpenResult: 'Gespeicherte Arbeit öffnen',
  evidenceOpenUrl: 'Webseite öffnen',
  evidenceOpenDecision: 'Entscheidung öffnen',
  evidenceOpenReference: 'Referenz öffnen',
  evidenceDecisionNote: 'Eine festgehaltene Entscheidung. In Poneva gibt es dazu nichts zu öffnen.',
  evidenceFactGone: 'Dieser Unternehmenskontext ist nicht mehr gespeichert.',
  evidencePageNoRevision: 'Diese Seite hat keine freigegebene Revision, die geöffnet werden kann.',
  evidencePrivateExcerpt: 'Privater Beleg – nur der Auszug oben wurde geteilt.',
  evidencePrivate: 'Privater Beleg – sein Inhalt wurde nicht mit Ihnen geteilt.',
  evidenceHeading: 'Belege',
  evidenceNone: 'Es wurden keine Belege angehängt. Bewerten Sie die Begründung oben für sich.',
  changeAdded: 'Hinzugefügt',
  changeRemoved: 'Entfernt',
  changeChanged: 'Geändert',
  changeUnchanged: 'Unverändert',
  moreLineCount: 'one:weitere Zeile|other:weitere Zeilen',
  moreUnchangedLineCount: 'one:weitere unveränderte Zeile|other:weitere unveränderte Zeilen',
  unchangedLineCount: 'one:unveränderte Zeile|other:unveränderte Zeilen',
  skipAdded: '{lines} – in der vollständigen Revision zu sehen',
  skipRemoved: '{lines} entfernt',
  cutUnchanged: '{lines} nicht angezeigt',
  cutChanged: '{lines} nicht angezeigt, {changes}. Prüfen Sie sie in der vollständigen Revision.',
  cutAddedRemoved: '{added} hinzugefügt und {removed} entfernt',
  cutAdded: '{added} hinzugefügt',
  cutRemoved: '{removed} entfernt',
  lineAddedSr: 'Hinzugefügt:',
  lineRemovedSr: 'Entfernt:',
  noLinesAdded: 'Ein neuer Abschnitt. Sein Text steht unten in der vollständigen Revision.',
  noLinesRemoved: 'Dieser Abschnitt würde von der Seite entfernt.',
  noLinesChanged:
    'Dieser Abschnitt ändert sich. Sein Text steht unten in der vollständigen Revision.',
  diffHeading: 'Änderungen',
  outcomeArchived: 'Archiviert.',
  outcomeArchivedBody:
    '{title} fließt nicht mehr in Antworten ein und ist nicht mehr in der Seitenliste. Ihre Revisionen, dieser Vorschlag und die Entscheidung bleiben im Seitenverlauf.',
  openArchivedPage: 'Archivierte Seite öffnen',
  outcomeApproved: 'Freigegeben.',
  outcomeApprovedRevision: 'Revision {n} ist jetzt die freigegebene Version von {title}.',
  outcomeApprovedPlain: 'Dieser Vorschlag wurde freigegeben.',
  outcomeRestored: 'Die Seite ist wieder in der Seitenliste und fließt wieder in Antworten ein.',
  outcomeKept:
    'Der Vorschlag, die Entscheidung und jede frühere Revision bleiben im Seitenverlauf.',
  openPage: 'Seite öffnen',
  outcomeDismissed: 'Verworfen.',
  outcomeWithdrawn: 'Zurückgezogen.',
  outcomeSuperseded: 'Überholt.',
  outcomeSupersededBody:
    'Eine neuere Revision, ein neuerer Vorschlag oder ein Repository-Import hat diesen Vorschlag überholt. Er selbst hat nichts geändert.',
  outcomeUnchanged: 'Die Seite bleibt unverändert.',
  approveNewPage: 'Neue Seite freigeben',
  approveArchive: 'Archivierung freigeben',
  approveRestoreRevision: 'Revision {n} wiederherstellen und freigeben',
  approveRevision: 'Revision {n} freigeben',
  approveArchiveNote: 'Mit der Freigabe wird diese Seite für alle bei {company} archiviert.',
  approvePublishNote: 'Mit der Freigabe wird diese Revision für alle bei {company} veröffentlicht.',
  approvePublishEvidenceNote:
    'Mit der Freigabe werden diese Revision und die oben gezeigten Belegauszüge für alle bei {company} veröffentlicht.',
  archivedTitle: 'Diese Seite ist archiviert.',
  alreadyArchivedBody:
    'Eine Freigabe würde nichts ändern, daher kann dieser Vorschlag nur verworfen werden.',
  archivedRestoreBody:
    'Mit der Freigabe wird sie wiederhergestellt: Die Seite kehrt mit dieser Revision in die Seitenliste, die Suche und die Antworten zurück.',
  staleRevisionAction: 'Mit der neuesten Version vergleichen',
  staleProposalTitle: 'Dieser Vorschlag wurde geändert, während Sie ihn geprüft haben.',
  staleProposalAction: 'Neueste Version prüfen',
  staleArchivedTitle:
    'Diese Seite wurde archiviert, während Sie sie geprüft haben. Eine Freigabe dieses Vorschlags würde sie zurückholen.',
  staleArchivedAction: 'Erneut prüfen',
  suggestionMissingTitle: 'Dieser Vorschlag ist nicht verfügbar.',
  suggestionMissingBody:
    'Er wurde möglicherweise zurückgezogen, oder er gehört einer anderen Person und wurde nicht zur Prüfung im Unternehmen gesendet.',
  decideUnconfirmed:
    'Wir konnten Ihre Entscheidung nicht bestätigen. Der angezeigte Status ist der neueste aus Poneva; prüfen Sie ihn, bevor Sie es erneut versuchen.',
  decideFailed: 'Wir konnten Ihre Entscheidung nicht speichern.',
  discussPrompt:
    'Hilf mir, die vorgeschlagene Wissensänderung an „{title}“ ({link}) zu verbessern.',
  conflictBody:
    'Dieser Vorschlag wurde auf Basis von Revision {base} verfasst; die aktuelle Revision ist {current}. Eine Freigabe würde diese Änderung überschreiben, daher kann er so nicht freigegeben werden.',
  conflictBodyPlain:
    'Dieser Vorschlag wurde auf Basis einer früheren Revision verfasst, daher kann er so nicht freigegeben werden.',
  openLatest: 'Neueste Version öffnen',
  reworkInChat: 'Im Chat überarbeiten',
  factReason: 'Begründung',
  factNoReason: 'Es wurde keine Begründung angegeben.',
  factAudience: 'Zielgruppe',
  factRevision: 'Revision',
  revisionNew: 'Eine neue Seite, Revision 1',
  revisionArchiveAfter: 'Archivierung nach Revision {n}',
  revisionWrittenAgainst:
    'Auf Basis von Revision {base} verfasst; die aktuelle Revision ist {current}',
  revisionCurrentToProposed: 'Aktuelle Revision {base} → vorgeschlagene Revision {next}',
  revisionProposed: 'Vorgeschlagene Revision {next}',
  proposedPage: 'Vorgeschlagene Seite',
  archivingHeading: 'Was die Archivierung bewirkt',
  archivingBody:
    'Die Seite fließt nicht mehr in Antworten ein und verschwindet aus der Seitenliste. Ihre Revisionen und diese Entscheidung bleiben erhalten.',
  noComparison: 'Für diesen Vorschlag ist kein Abschnittsvergleich verfügbar.',
  showComplete: 'Vollständige Revision anzeigen',
  approving: 'Wird freigegeben…',
  dismissing: 'Wird verworfen…',
  dismiss: 'Verwerfen',
  withdrawing: 'Wird zurückgezogen…',
  withdraw: 'Zurückziehen',
  editInChat: 'Im Chat bearbeiten',
  waitingForPublisher:
    'Wartet auf Prüfung durch eine Person mit Veröffentlichungsrechten im Unternehmen.',
  snapshotTooLarge:
    'Dieser Snapshot ist größer als 8 MB. Erstellen Sie ihn mit weniger Dokumenten.',
  snapshotNotSnapshot:
    'Diese Datei ist kein Wissens-Snapshot. Wählen Sie die JSON-Datei, die das Snapshot-Skript geschrieben hat.',
  snapshotEmpty: 'Dieser Snapshot enthält keine Dokumente.',
  readDocumentFailed: 'Wir konnten dieses Dokument nicht lesen. Versuchen Sie es erneut.',
  readingDocument: 'Dokument wird gelesen…',
  hideText: 'Text ausblenden',
  readText: 'Text lesen',
  textOf: 'Text von {title}',
  gitSnapshot: 'Git-Snapshot {commit}',
  repositorySnapshot: 'Repository-Snapshot',
  importNewHeading: '{pages} · beim Übernehmen freigegeben',
  importNewNote:
    'Jede wird ohne weitere Prüfung als freigegebene Seite für alle bei {company} veröffentlicht. Lesen Sie jede, bevor Sie übernehmen.',
  importChangedHeading: '{pages} · zur Prüfung gesendet',
  importChangedNote:
    'Jede wird zu einer vorgeschlagenen Änderung. Die Seite ändert sich erst, wenn eine Person mit Veröffentlichungsrechten sie unter Zur Prüfung freigibt, wo die Änderungen angezeigt werden.',
  unchangedDocumentCount: 'one:unverändertes Dokument|other:unveränderte Dokumente',
  unchangedNote:
    'Diese stimmen bereits mit ihren freigegebenen Seiten überein. Für sie wird nichts geschrieben.',
  stagedHeading: 'Bereitgestellt, aber nicht übernommen',
  excludedSummary: '{documents} aus diesem Snapshot ausgelassen',
  countsLine: '{newPages} · {changedPages} zur Prüfung · {unchanged} unverändert',
  importAlreadyDiscarded: 'Dieser Import wurde bereits verworfen.',
  confirmLabel: 'Import bestätigen',
  unchangedKeepCount:
    'one:unverändertes Dokument behält seine Seite|other:unveränderte Dokumente behalten ihre Seiten',
  confirmBody:
    'Diesen Import für alle bei {company} übernehmen? {newPages} werden als Revision 1 freigegeben, {changedPages} warten auf Prüfung, und {unchanged}. Frühere Importvorschläge für diese Seiten werden zurückgezogen.',
  applying: 'Wird übernommen…',
  applyImport: 'Import übernehmen',
  chooseAnother: 'Andere Datei wählen',
  allCurrent: 'Alles in diesem Snapshot ist bereits aktuell.',
  importApplied: 'Import übernommen.',
  appliedSummary: '{pages} erstellt · {changes} warten auf Prüfung · {unchanged} unverändert.',
  appliedIndexing:
    'Neue Seiten sind im Chat durchsuchbar, sobald die Indexierung abgeschlossen ist. Den Fortschritt sehen Sie unter Quellenvorbereitung.',
  openPages: 'Seiten öffnen',
  reviewChanges: '{changes} prüfen',
  checkIndexing: 'Indexierungsfortschritt prüfen',
  sendSnapshotFailed: 'Wir konnten diesen Snapshot nicht senden. Versuchen Sie es erneut.',
  openStagedFailed: 'Wir konnten diesen bereitgestellten Import nicht öffnen.',
  applyUnconfirmed:
    'Wir konnten nicht bestätigen, ob der Import übernommen wurde. Prüfen Sie Seiten, bevor Sie es erneut versuchen.',
  applyFailed: 'Wir konnten diesen Import nicht übernehmen.',
  importHeading: 'Seiten aus dem Repository importieren',
  backToPages: 'Zurück zu den Seiten',
  importLead:
    'Erstellen Sie mit {command} einen Snapshot und wählen Sie dann die Datei. Sie sehen jedes Dokument und was es ändern würde, bevor etwas gespeichert wird.',
  snapshotFileLabel: 'Wissens-Snapshot-Datei',
  readingSnapshot: 'Snapshot wird gelesen…',
  openingStaged: 'Bereitgestellter Import wird geöffnet…',
  chooseSnapshot: 'Snapshot-Datei wählen',
  factOrigin: 'Herkunft',
  factContents: 'Inhalt',
  importOnlyListed: 'Nur die hier aufgeführten Dokumente werden importiert.',
  importRepositoryAuthoritative:
    'Das Repository bleibt maßgeblich; geänderte Dokumente werden zu Vorschlägen zur Prüfung.',
  overviewReviewChanges: 'Änderungen prüfen',
  overviewConnectAgents: 'Externe Agenten verbinden',
  overviewEyebrow: 'Ein gemeinsames Verständnis',
  overviewTitle: '{company} im Kontext.',
  overviewLeadFallback:
    'Das Wissen Ihres Unternehmens beginnt mit dem Kontext, den Sie teilen. Bauen Sie gemeinsam ein Verständnis Ihres Geschäfts auf.',
  overviewBody:
    'Unternehmenskontext und Quellenmaterial geben Poneva einen Ausgangspunkt – nicht alles, was es über {company} zu wissen gibt. Bauen Sie dieses Verständnis weiter aus, während sich Ihr Geschäft entwickelt.',
  overviewAskPrompt: 'Was weißt du über unser Unternehmen, und was wäre sinnvoll zu ergänzen?',
  overviewAsk: 'Zu {company} fragen',
  overviewAddSources: 'Quellen hinzufügen',
  contextEyebrow: 'Was Antworten Kontext gibt',
  contextTitle: 'Das Geschäft hinter der Frage.',
  contextBody:
    'Website-Quellen erklären das öffentliche Geschäft. Unternehmensnotizen ergänzen Ihre Begriffe, Prioritäten und Ihre Arbeitsweise.',
  contextPrompt:
    'Hilf mir, die Prioritäten und Arbeitsweisen unseres Unternehmens zu klären, die wir festhalten sollten.',
  contextAction: 'Unser Verständnis aufbauen',
  learnEyebrow: 'Raum zum Lernen',
  learnTitle: 'Beginnen Sie mit dem, was als Nächstes zählt.',
  learnBody:
    'Bringen Sie Quellenmaterial ein oder klären Sie, wie Ihr Unternehmen arbeitet. Poneva kann dauerhafte Änderungen vorschlagen, die Sie prüfen.',
  learnPrompt:
    'Welche wichtigen Informationen fehlen in unserem bisherigen Unternehmenswissen für die Arbeit, die wir vorhaben?',
  learnAction: 'Besprechen, was nützlich wäre',
  canvasEmptyTitle: 'Schon wenig Kontext bewirkt viel.',
  canvasEmptyBody:
    'Ihr Unternehmensprofil ist der Ausgangspunkt. Fügen Sie Quellenmaterial und geprüfte Notizen hinzu, damit Poneva Ihre Arbeit versteht.',
  pageEyebrow: 'Arbeitsbereich {company}',
  pageTitle: 'Unternehmenswissen',
  pageDescription: 'Die Quellen und das Verständnis hinter Ponevas Arbeit.',
  tabOverview: 'Übersicht',
  tabPages: 'Seiten',
  tabSources: 'Quellen',
  tabReview: 'Zur Prüfung',
  proposalApproved: 'Freigegebener Unternehmenskontext',
  proposalDismissed: 'Verworfener Vorschlag',
  proposalRemoval: 'Vorgeschlagene Entfernung',
  proposalCorrection: 'Vorgeschlagene Korrektur',
  proposalContext: 'Vorgeschlagener Unternehmenskontext',
  proposalCurrent: 'Aktueller Stand',
  proposalFactGone:
    'Der gespeicherte Fakt ist nicht mehr verfügbar. Aktualisieren Sie das Unternehmenswissen, bevor Sie diese Entfernung prüfen.',
  proposalReviewFallback: 'Prüfen Sie den vorgeschlagenen Unternehmenskontext.',
  proposalNotSaved: 'Noch nicht gespeichert. Die Originalquellen bleiben unverändert.',
  proposalWaiting:
    'Wartet auf Prüfung · eine Person mit Veröffentlichungsrechten entscheidet in ihrem Posteingang',
  proposalSaving: 'Wird gespeichert…',
  proposalApproveRemoval: 'Entfernung freigeben',
  proposalApproveClarification: 'Klarstellung freigeben',
  factLabel: 'Unternehmensfakt',
  factEyebrow: 'Fakt · Alle bei {company}',
  factSuggestCorrection: 'Korrektur vorschlagen',
  factAskPrompt:
    'Hilf mir, diesen gespeicherten Unternehmenskontext zu verstehen oder zu klären: „{content}“',
  factAsk: 'Dazu fragen',
  companyContextHeading: 'Unternehmenskontext',
  companyContextPrompt:
    'Ich möchte unser Unternehmenswissen klären. Hilf mir, zu prüfen, was wir wissen, und eine Aktualisierung vorzuschlagen.',
  companyContextEmpty:
    'Noch keine freigegebenen Notizen. Beginnen Sie ein Gespräch über Ihr Unternehmen oder fügen Sie unten Quellenmaterial hinzu.',
  refineInChat: 'Im Chat verfeinern',
  reviewPanelLabel: 'Wissensänderungen zur Prüfung',
  suggestedUpdatesHeading: 'Vorgeschlagene Änderungen',
  suggestedUpdatesIntro:
    'Vorschläge aus Ihren Gesprächen. Sie entscheiden, was dauerhaft zum Wissen Ihres Unternehmens wird.',
  reviewEmptyTitle: 'Nichts wartet auf Ihre Prüfung.',
  reviewEmptyBody:
    'Wenn Poneva eine Änderung an Ihrem Unternehmenswissen vorschlägt, finden Sie sie hier. Dauerhafte Änderungen brauchen immer Ihre Freigabe.',
  reviewEmptyPrompt:
    'Hilf mir, unser Unternehmenswissen zu prüfen, und schlag vor, was als Nächstes sinnvoll zu klären wäre.',
  inclusionPendingApproval: 'Änderung der Aufnahme ins Wissen zur Freigabe gesendet.',
  sourcesFileIncluded: 'Datei für ihre aktuelle Zielgruppe in die Wissenssuche aufgenommen.',
  sourcesAddFailed: 'Diese Quelle konnte nicht hinzugefügt werden.',
  sourcesHeading: 'Das Material hinter den Antworten.',
  sourcesIntro:
    'Poneva durchsucht das gesamte Quellenmaterial, nicht nur die Übersicht. Bewahren Sie Originale auf, sehen Sie, was bereit ist, und wählen Sie, was in Ihre Antworten einfließt.',
  addSourceHeading: 'Material aus Ihrem Unternehmen hinzufügen',
  addSourceIntro:
    'Hochgeladene Quellen bleiben privat in Ihrer Bibliothek und fließen in Ihre eigenen Antworten ein. Wählen Sie Teilen, wenn Sie sie Kolleginnen und Kollegen zur Verfügung stellen möchten.',
  uploadSource: 'Quelle hochladen',
  addSourcePrompt:
    'Hilf mir, eine Unternehmensaussage als gemeinsame interne Quelle hinzuzufügen. Frag mich, was ich festhalten möchte, und erfinde keine Inhalte. Dauerhafte Änderungen am Unternehmensverständnis brauchen weiterhin meine Freigabe.',
  addThroughChat: 'Über den Chat hinzufügen',
  addingSource: 'Wird hinzugefügt…',
  addToKnowledge: 'Zum Wissen hinzufügen',
  uploadFormats: 'TXT, Markdown, CSV und JSON · Bis zu 5 MB pro Datei',
  sourceExcluded: 'Von Antworten ausgeschlossen',
  sourcePreparationFailed: 'Vorbereitung fehlgeschlagen',
  sourcePreparing: 'Wird für die Suche vorbereitet',
  sourceWaiting: 'Wartet auf Vorbereitung',
  sourceReadinessUnknown: 'Bereitschaft nicht verfügbar',
  sourceRetryQueued:
    'Vorbereitung eingeplant. Die Bereitschaft wird aktualisiert, sobald sie abgeschlossen ist.',
  sourceIncludedNotice: 'Quelle aufgenommen. Poneva bereitet sie für die Suche vor.',
  sourceExcludedNotice: 'Von Antworten ausgeschlossen. Die Originalquelle bleibt erhalten.',
  sourceUpdateFailed: 'Diese Quelle konnte nicht aktualisiert werden.',
  sourceOriginalMaterial: 'Originales Quellenmaterial',
  sourceDiscuss: 'Im Chat besprechen',
  sourceDiscussPrompt: 'Hilf mir, „{title}“ zu verstehen oder zu klären.',
  sourceExclude: 'Von Antworten ausschließen',
  sourceInclude: 'In Antworten aufnehmen',
  sourcesLoadFailed: 'Wir konnten Ihre Quellen nicht laden.',
  sourceLibraryLabel: 'Quellenbibliothek des Unternehmens',
  sourceListCaption: 'Originalquellen · aufgenommen und ausgeschlossen',
  sourceSearchLabel: 'Unternehmensquellen durchsuchen',
  sourceSearchPlaceholder: 'Quellen durchsuchen…',
  sourcesFinding: 'Quellen werden gesucht…',
  sourcePagesLabel: 'Quellenseiten',
  sourceRange: '{from}–{to} von {count}',
  sourceCount: 'one:Quelle|other:Quellen',
  sourcePrevious: 'Zurück',
  sourceNext: 'Weiter',
  sourceNoMatchTitle: 'Keine passenden Quellen.',
  sourceNoMatchBody: 'Versuchen Sie einen anderen Begriff oder Quellennamen.',
  sourceEmptyTitle: 'Geben Sie Ihren Fragen eine stärkere Grundlage.',
  sourceEmptyBody:
    'Fügen Sie Unternehmensdokumente, Produktdaten oder Arbeitsnotizen hinzu. Poneva kann das gesamte Quellenmaterial in Gesprächen und Skills nutzen.',
  indexCheckFailed: 'Wir konnten die Quellenvorbereitung nicht prüfen.',
  indexRetryQueued:
    'Fehlgeschlagene Wissenseinträge zur Vorbereitung eingeplant. Ihr Quellenmaterial bleibt unverändert.',
  indexQueueFailed: 'Wir konnten die Vorbereitung nicht einplanen. Versuchen Sie es erneut.',
  indexPreparing: 'Neues Wissen wird für Ihre Gespräche vorbereitet…',
  indexAttention: 'Ein Teil des Wissens braucht Aufmerksamkeit.',
  queuing: 'Wird eingeplant…',
  retryPreparation: 'Vorbereitung wiederholen',
  sourceKindStatement: 'Unternehmensaussage',
  sourceKindWebsite: 'Website',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:Antwort|other:Antworten',
  factUsedThisWeek: 'Diese Woche in {answers} verwendet',
  factLastUsed: 'zuletzt verwendet: {when}',
  factToday: 'heute',
  factYesterday: 'gestern',
  factImpact: 'Diese Änderung betrifft einen Fakt, der diese Woche in {answers} verwendet wurde.',
  factCorrectionAbout: 'Zu diesem Unternehmensfakt: „{content}“ ({link})',
  factCorrectionOutdated: 'Das ist nicht mehr aktuell:',
  sourceCanvasRecorded: 'Erfasstes Quellenmaterial',
  sourceCanvasNotIncluded:
    'Nicht im Unternehmenswissen enthalten. Das Original bleibt zur Referenz erhalten und kann weiterhin in einem bestimmten Gespräch verwendet werden.',
  sourceCanvasOpenOriginal: 'Originalquelle öffnen',
  sourceCanvasUnavailable: 'Der Inhalt der Quelle ist nicht verfügbar.',
  sourceCanvasDiscussPrompt: 'Hilf mir, „{title}“ zu verstehen oder zu klären.',
  sourceCanvasDiscuss: 'Diese Quelle besprechen',
  sourceCanvasCorrectionNote:
    'Eine Korrektur wird zu vorgeschlagenem Unternehmenskontext. Die erfasste Quelle bleibt unverändert.',
  contextCanvasEyebrow: 'Verfügbarer Unternehmenskontext',
  contextCanvasTitle: 'Das Wissen hinter diesem Gespräch.',
  contextCanvasBody:
    'Freigegebenes Wissen und das Quellenmaterial, das Ihr Unternehmen hinzugefügt hat. Verfügbar im Chat und in Skills.',
  contextCanvasOpen: 'Wissen öffnen',
};

export default de;
